export { default as AltText } from './AltText';
export { default as Body } from './Body';
export { default as Eyebrow } from './Eyebrow';
export { default as Headline } from './Headline';
export { default as Hero } from './Hero';
export { default as Subheading } from './Subheading';
